<template>
	<div class="border-t border-gray-400 max-w-full flex-shrink-0 text-sm pt-2">
		<div v-for="(total, index) in value" :key="index" class="flex mb-1">
			<div class="break-words flex-shrink flex-grow">
				{{ total.title }}
			</div>
			<div class="text-right">
				<Price :value="total.value"></Price>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import Price from "../../ui/Price.vue"
import {CartTotalInterface} from "@/js/interfaces/cart"

defineProps<{
	value: CartTotalInterface[]
}>()
</script>
